module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b3b57e9c1d3b49abab1d9c1d94a273a9.png";